// app/frontend/components/layouts/UserContext.tsx
import React, { createContext, useContext, useMemo } from "react";
import type { User } from "../components/layouts/types";

/**
 * UserContext
 * - Provides mock authentication for now
 * - Defaults to isAuthenticated=true and a mock user
 * - Can later accept a real user object (e.g., from Inertia page props)
 */

type UserContextValue = {
  user: User | null;
  isAuthenticated: boolean;
};

const mockUser: User = {
  id: 1,
  name: "Learntokiz Demo User",
  email: "demo@learntokiz.com",
  avatarUrl:
    "https://api.dicebear.com/8.x/thumbs/svg?seed=learntokiz-user&radius=50",
};

const UserContext = createContext<UserContextValue>({
  user: mockUser,
  isAuthenticated: true,
});

export function UserProvider({
  children,
  userFromServer,
}: {
  children: React.ReactNode;
  userFromServer?: User | null;
}) {
  const value = useMemo(() => {
    const user =
      typeof userFromServer === "undefined" ? mockUser : userFromServer;
    return { user, isAuthenticated: !!user };
  }, [userFromServer]);

  return <UserContext.Provider value={value}>{children}</UserContext.Provider>;
}

export function useUser() {
  return useContext(UserContext);
}
